export default function onChangeDropdown<T = unknown>(
  name: string,
  onChange: (a: { target: { name: string; value: T } }) => void
): (value: T) => void {
  return (value: T) => {
    onChange({ target: { name, value } });
  };
}
